import keys from "../secrets-web/src/config/keys";
export default {
  ...keys
}